const exportCenter = (request, api_config) => {
  const prefix = "ExportCenter";

  const ExportCheckWorkList = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/ExportCheckWorkList`,
      method: "post",
      data: data,
      responseType: "blob",
    });
    return result;
  };

  const ExportMyStoreCheckWorkList = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/ExportMyStoreCheckWorkList`,
      method: "post",
      data: data,
      responseType: "blob",
    });
    return result;
  };

  const ExportStockBatchOrderList = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/ExportStockBatchOrderList`,
      method: "post",
      data: data,
      responseType: "blob",
    });
    return result;
  };

  const ExportStockBarcodeList = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/ExportStockBarcodeList`,
      method: "post",
      data: data,
      responseType: "blob",
    });
    return result;
  };

  return {
    ExportCheckWorkList,
    ExportMyStoreCheckWorkList,
    ExportStockBatchOrderList,
    ExportStockBarcodeList,
  };
};

export default exportCenter;
